'use client';

import { createContext, ReactNode, useContext } from 'react';
import { EnvConfig } from '../types/config';

export const getConfig = (
  publicRuntimeEnv: Record<string, string>,
): EnvConfig => ({
  apiURL: publicRuntimeEnv.API_URL || 'http://localhost:8000',
  storageURL: publicRuntimeEnv.STORAGE_URL || 'http://localhost:9000',
});

const EnvConfigReactContext = createContext<EnvConfig>(getConfig({}));

interface EnvConfigProviderProps {
  publicRuntimeEnv: Record<string, string>;
  children: ReactNode;
}

export function EnvConfigProvider({
  publicRuntimeEnv,
  children,
}: EnvConfigProviderProps) {
  const config = getConfig(publicRuntimeEnv);
  return (
    <EnvConfigReactContext.Provider value={config}>
      {children}
    </EnvConfigReactContext.Provider>
  );
}

export const useConfig = (): EnvConfig => {
  const context = useContext(EnvConfigReactContext);
  if (!context) {
    throw new Error('useConfig must be used within an EnvConfigProvider');
  }
  return context;
};
